import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { curlocation, pagesState, mySession, loginAsync, checkSessionAsync, onsessionAsync, MyLibraryLogInAsync, myLibs } from './controller';
import useDynamicRefs from 'use-dynamic-refs';

export function Login() {

    const dispatch = useDispatch();
    const pages_state = useSelector(pagesState);
    const cur_location = useSelector(curlocation);
    const my_Session = useSelector(mySession);
    const my_Libs = useSelector(myLibs);
    const [getRef, setRef] = useDynamicRefs();

    const GetSessionAndLoginURL = async () => {
        const redirectUrl = {
            "CallBackUrl": process.env.REACT_APP_LOGIN_CALLBACKURL
        }
        await  dispatch(checkSessionAsync());
        return dispatch(MyLibraryLogInAsync(redirectUrl));
    }
    var [loginMethod, setloginMethod] = useState(0);
    var handleLoginMethod = (index) => setloginMethod(index);

    useEffect(() => {
        GetSessionAndLoginURL()
    }, []);

    const loginFormSubmit = (e) => {
        e.preventDefault();
        var data = {
            loginValue: getRef('userInfo').current.value
        }
        dispatch(loginAsync(data));
     
    }

    const triggercheck = () => {
        dispatch(checkSessionAsync());
    }

    return (
        <section id="login">
            {(pages_state.status !== 'idle' || pages_state.status === 'rejected') && <div className="position-fixed loadingScreen d-flex justify-content-center align-items-center"><img src="./images/loading.gif" className="icons-loading" alt="" /></div>}
            <div className="container-fluid mt-3 disclaimer minHeight">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <h2 className="pageTitle mt-2">Welcome!</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 mb-3">
                            <div className="card overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body">
                                    <div>
                                        <p className="theme-color fw-bold faqTitle">Login via:</p>
                                        <div>
                                            <label htmlFor="requestID">
                                                <input type="radio" name="loginas" id="requestID" className="me-2" checked={loginMethod === 0} onChange={() => handleLoginMethod(0)} />
                                                Email / Request ID
                                            </label>

                                        </div>
                                        {my_Libs && !my_Libs.isMylibsLogin && <div className="mt-1">
                                            <label htmlFor="myLibraryID">
                                                <input type="radio" name="loginas" id="myLibraryID" className="me-2" checked={loginMethod === 1} onChange={() => handleLoginMethod(1)} />
                                                NLB myLibrary
                                            </label>
                                        </div>}

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="card overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex justify-content-center">
                                    <div className="card-content">
                                        {loginMethod === 0 && <div>
                                            <form onSubmit={(e) => loginFormSubmit(e)} id="loginForm">
                                                <label htmlFor="username" className="col-form-label">Email / Request ID<span className="text-danger">*</span>:</label>
                                                <div>
                                                    <input type="text" className="form-control w-100" id="username" placeholder="Email Address or Request ID" ref={setRef('userInfo')} autoComplete="off" required />
                                                </div>
                                                <div className="mt-3">
                                                    <button type="submit" className="btn btn-primary">Log in</button>
                                                </div>
                                            </form>
                                        </div>}
                                        {loginMethod === 1 && <div className="d-flex justify-content-center mt-3">
                                            <a className="ui-theme-btn btn-mylibrary cursor_pointer" title="Login using your NLB account." target="_self" href={pages_state ? pages_state.dataUrl : '#'}>
                                                <img style={{ maxHeight: '31px', width: 'auto' }} src="./images/nlb-logo-white.svg" alt="" /> <span
                                                    className="px-1">NLB myLibrary</span> <span style={{ fontSize: '20px' }} className="material-icons-outlined align-middle">chevron_right</span> </a>
                                        </div>}
                                        <div className="alert alert-info mt-5">
                                            <p className="mb-2">By logging in, I agree to the following terms of use:</p>
                                            {cur_location && cur_location.LocationCode === 'H' && <ol>
                                                <li>I shall use the contents of archives or any copy made of archives only for the research topic
                                                    and scope set out in my submitted request. I will submit a new request if I need to access these
                                                    records for other purposes.</li>
                                                <li>I shall comply with any access or other conditions set out in the research database or as
                                                    advised by the archivist on duty. I am aware that by downloading the records, I agree to the
                                                    terms of use as outlined here <Link to="/faq">FAQ</Link></li>
                                                <li>I shall not disclose the personal data of any person found in the archives without prior written
                                                    permission.</li>
                                            </ol>}
                                            {cur_location && cur_location.LocationCode === 'OP' && <ol>
                                                <li>I shall use the contents of archives or any copy made of archives only for the research topic
                                                    and scope set out in my submitted request. I will submit a new request if I need to access these
                                                    records for other purposes.</li>
                                                <li>I shall comply with any access or other conditions set out in the research database or as
                                                    advised by the archivist on duty. I am aware that while I may take photos or make reproductions
                                                    of these records for reference purposes, written permission is required to use it in a public
                                                    setting. Video/audio recording of the records is not permitted unless with express permission by
                                                    the archivist on duty.</li>
                                                <li>I shall not disclose the personal data of any person found in the archives without prior written
                                                    permission.</li>
                                                <li>I accept that I may be asked to present my identification documents or passport for verification
                                                    and shall comply with any other rules relating to usage of the Archives Reading Room.</li>
                                                <li>
                                                    I can use these terminals during the Archives Reading Room's opening hours. I am aware that the
                                                    terminals will auto-shutdown and I will ensure to take note of where I have left off in my
                                                    research. Unless otherwise stated in the announcements on-site, the opening hours are:
                                                    Mon - Sun: 10am to 9pm
                                                </li>
                                            </ol>}
                                            {cur_location && cur_location.LocationCode === 'OR' && <ol>
                                                <li>I shall use the contents of archives or any copy made of archives only for the research topic
                                                    and scope set out in my submitted request. I will submit a new request if I need to access these
                                                    records for other purposes.</li>
                                                <li>I shall comply with any access or other conditions set out in the research database or as
                                                    advised by the archivist on duty. I am aware that I cannot make unauthorised reproductions of
                                                    content on these terminals as the records are restricted and written permission is required to
                                                    quote or make reproductions. Conditions depend on the requirements that may be set by donors,
                                                    copyright owners or rights holders.</li>
                                                <li>I shall not disclose the personal data of any person found in the archives without prior written
                                                    permission.</li>
                                                <li>I accept that I may be asked to present my identification documents or passport for verification
                                                    and shall comply with any other rules relating to usage of the Archives Reading Room.</li>
                                                <li>
                                                    I can use these terminals only during the Archives Reading Room's staffed service hours. I am
                                                    aware that the terminals will auto-shutdown and I will ensure to take note of where I have left
                                                    off in my research. Unless otherwise stated in the announcements on-site, the staffed service
                                                    hours are:
                                                    Mon - Fri: 10am - 6.30pm
                                                    Sat: 10am - 1pm
                                                </li>
                                            </ol>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





